/**
 * Constantes de errores centralizadas para AgroError
 * Cada error define:
 * - title: Título del error
 * - subtitle: Subtítulo con mensaje explicativo
 * - image: Nombre de la imagen en /assets/img/
 * - hasAction: Si tiene acción de reintento
 * - action: Nombre de la action a ejecutar
 * - actionPayload: Payload dinámico (se completa al disparar el error)
 * - buttonLabel: Etiqueta del botón (opcional)
 * - returnRoute: Ruta a donde volver
 * - successAction: Action a ejecutar si el reintento es exitoso
 * - tituloMaxIntentos: Título alternativo al alcanzar máximo de intentos
 * - subtituloMaxIntentos: Subtítulo alternativo al alcanzar máximo de intentos
 */

export const genericTitle = "Información no disponible";
export const genericSubtitle =
  "En este momento no podemos procesar la solicitud. <br/> Intentá nuevamente más tarde";
export const genericImage = "agro/feedback/error.svg";
export const genericButtonLabelAceptar = "Aceptar";
export const genericButtonLabelVolver = "Volver";

export const AGRO_ERROR_TYPES = {
  GENERIC_ERROR_WITH_RETRY: {
    title: genericTitle,
    subtitle: "Intentá de nuevo",
    image: genericImage,
    hasAction: true,
    tituloMaxIntentos: genericTitle,
    subtituloMaxIntentos: genericSubtitle,
    buttonLabel: "Reintentar"
  }
};

/**
 * Helper para crear un objeto de error con payload personalizado
 * @param {string} errorType - Clave del tipo de error (de AGRO_ERROR_TYPES)
 * @param {object} customPayload - Payload personalizado (opcional)
 * @returns {object} Objeto de error completo
 */
export const createAgroError = (errorType, customPayload = {}) => {
  const baseError =
    AGRO_ERROR_TYPES[errorType] || AGRO_ERROR_TYPES.GENERIC_ERROR_WITH_RETRY;

  return {
    ...baseError,
    ...customPayload
  };
};

/**
 * Obtener error por tipo
 * @param {string} errorType - Clave del tipo de error
 * @returns {object} Objeto de error
 */
export const getAgroError = errorType => {
  return (
    AGRO_ERROR_TYPES[errorType] || AGRO_ERROR_TYPES.GENERIC_ERROR_WITH_RETRY
  );
};
